import { SlideUpModal } from "src/components/SlideUpModal";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useWebClientApi } from "src/api";

type DeleteAccountModalProps = {
  isOpen: boolean;
  financialAccountId: string;
  closeHandler: () => void;
  deleteHandler: () => void;
};

export default ({
  isOpen,
  financialAccountId,
  closeHandler,
  deleteHandler,
}: DeleteAccountModalProps) => {
  const api = useWebClientApi();
  const [submitDelete, loading] = useDlaFormSubmit(
    async () => {
      await api.deleteAsset(financialAccountId);
    },
    {
      onSuccess: () => deleteHandler(),
    },
  );

  if (!isOpen) return null;

  return (
    <SlideUpModal
      title="Remove this account"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Remove"
      actionButtonClickHandler={() => void submitDelete({})}
      isLoading={loading}
    >
      This action cannot be undone.
    </SlideUpModal>
  );
};
